import { createClient } from "@supabase/supabase-js";

const defaultUrl = process.env.REACT_APP_SUPABASE_URL || "https://placeholder.supabase.co";
const defaultKey = process.env.REACT_APP_SUPABASE_ANON_KEY || "placeholder-key";

export let supabase = createClient(defaultUrl, defaultKey);

export function updateSupabaseConfig(newUrl, newKey) {
  if (newUrl && newKey) {
    supabase = createClient(newUrl, newKey);
  }
}
